import * as utils from './modules/utils';
import 'core-js/fn/symbol/for';
import 'core-js/fn/symbol/iterator';
import 'whatwg-fetch';
import bowser from 'bowser';
import Cookies from 'js-cookie';
import ValidForm from '@pageclip/valid-form';
import throttle from 'throttle-debounce/throttle';
//import debounce from 'throttle-debounce/debounce';

const moduleRegistration = function(m, u, ui, win, doc){

    // Document loaded class
    m.docLoad = () => {
        u.addClass(document.body, 'is-loaded');
        if(typeof browser !== 'undefined'){
            if(browser.name){
                u.addClass(document.body, bowser.name.replace(/\s+/g, '-').toLowerCase());
            }
            if(bowser.version){
                u.addClass(document.body, bowser.name.replace(/\s+/g, '-').toLowerCase() + '-' + bowser.version.replace(/\s+/g, '-').toLowerCase());
            }
        }
    };

    m.headerHeight = () => {
        const r = document.querySelector(':root');
        const header = doc.querySelector('.site-wrap > .header');

        const setHeaderHeight = () => {
            r.style.setProperty('--header-height', header.offsetHeight + 'px');
        };

        setHeaderHeight();
        win.addEventListener('resize', throttle(200, setHeaderHeight));
    };

    // Handle notice visibility
    m.Notices = function(){

        function showNotice(notice){
            u.addClass(notice, 'is-visible');
        }

        function hideNotice(notice){
            u.removeClass(notice, 'is-visible');
            Cookies.set(`notice-${notice.getAttribute('data-type')}`, true, { expires: 30 });
        }

        for(const notice of doc.getElementsByClassName('notice--closeable')) {
            if( Cookies.get(`notice-${notice.getAttribute('data-type')}`) === undefined ){
                showNotice(notice);
            }

            notice.querySelector('.notice__close').addEventListener('click', () => { hideNotice(notice); });
        }
    };

    m.mapHeight = () => {
        const wrapper = doc.querySelector('.page-wrap');
        const r = document.querySelector(':root');

        const calculate = () => {
            r.style.setProperty('--map-height', wrapper.offsetHeight + 'px');
        };

        win.addEventListener('resize', calculate);
        calculate();
    }

    m.regionToggle = () => {
        const triggers = doc.querySelectorAll('[data-region]');
        const closures = doc.querySelectorAll('.region__close, .region__back');
        const countries = doc.querySelectorAll('.region__countries');
        const map = doc.querySelector('.map__image');
        const regionResetEvent = new Event('region-reset');
        let activeRegion;

        if( !triggers ){
            return;
        }

        // Resetting active regions
        const reset = () => {

            if( activeRegion != undefined ){
                u.removeClass(doc.querySelector(`.map__image [data-region="${activeRegion}"]`), 'is-active');
                u.removeClass(doc.querySelector(`.region[data-region="${activeRegion}"] .region__trigger`), 'is-active');
                u.removeClass(doc.querySelector(`.region[data-region="${activeRegion}"] .region__countries`), 'is-active');
                u.removeClass(map, 'inactive');

                activeRegion = undefined;

                doc.dispatchEvent(regionResetEvent);
            }
        };

        // Handle opening a region
        const handleClick = e => {
            const newRegion = e.currentTarget.dataset.region;
            if( activeRegion == newRegion ){
                return;
            }

            reset();

            u.addClass(doc.querySelector(`.map__image [data-region="${newRegion}"]`), 'is-active');
            u.addClass(doc.querySelector(`.region[data-region="${newRegion}"] .region__trigger`), 'is-active');
            u.addClass(doc.querySelector(`.region[data-region="${newRegion}"] .region__countries`), 'is-active');
            u.addClass(map, 'inactive');

            activeRegion = newRegion;
        }

        for(const el of triggers){
            el.addEventListener('click', handleClick);
        }

        // Handle closing active region
        for(const el of closures){
            el.addEventListener('click', reset);
        }

        // Stop event bubbling up
        for(const el of countries){
            el.addEventListener('click', e => { e.stopPropagation(); });
        }
    }

    m.distributorsToggle = () => {
        const triggers = doc.querySelectorAll('.country__trigger');
        const closures = doc.querySelectorAll('.distributors__close, .distributors__back');
        const distributorsResetEvent = new Event('distributors-reset');

        if( !triggers ){
            return;
        }


        // Resetting active countrys
        const reset = () => {
            const activeDistributors = doc.querySelector(`.distributors.is-active`);
            if( activeDistributors ){
                u.removeClass(activeDistributors, 'is-active');
            }

            const activeTrigger = doc.querySelector(`.country__trigger.is-active`);
            if( activeTrigger ){
                u.removeClass(activeTrigger, 'is-active');
            }
        };

        // Handle opening country
        const handleClick = e => {
            const distributors = e.currentTarget.parentElement.querySelector('.distributors');

            reset();

            u.addClass(e.currentTarget, 'is-active');
            u.addClass(distributors, 'is-active');

            doc.dispatchEvent(distributorsResetEvent);
        }

        for( const el of triggers ){
            el.addEventListener('click', handleClick);
        }

        // Handle closing ctive country
        for(const el of closures){
            el.addEventListener('click', reset);
        }

        doc.addEventListener('region-reset', reset);
    }

    m.distributorToggle = () => {
        const triggers = doc.querySelectorAll('.distributors__trigger');
        const closures = doc.querySelectorAll('.distributor__header, .distributor__close, .distributor__back');

        if( !triggers ){
            return;
        }


        // Resetting active istributors
        const reset = () => {
            const activeDistributor = doc.querySelector(`.distributor.is-active`);
            if( activeDistributor ){
                u.removeClass(doc.querySelector(`.distributor.is-active`), 'is-active');
            }
        };

        // Handle opening districutor
        const handleClick = e => {
            const distributor = e.currentTarget.parentElement.querySelector('.distributor');

            reset();
            u.addClass(distributor, 'is-active');
        }

        for( const el of triggers ){
            el.addEventListener('click', handleClick);
        }

        // Handle closing active distributor
        for(const el of closures){
            el.addEventListener('click', reset);
        }

        doc.addEventListener('region-reset', reset);
        doc.addEventListener('distributors-reset', reset);
    }

};

class Site {

    constructor() {
        // DOM caching
        this.win = window;
        this.doc = document;

        this.doc.documentElement.setAttribute('data-ua',  navigator.userAgent);

        // Globals
        this.ui = {
            fast: 0.2,
            slow: 0.4,
            step: 0.03
        };
        this.modules = {};

        this.init();
    }

    init(){
        moduleRegistration(this.modules, utils, this.ui, this.win, this.doc);

        for (const prop in this.modules) {
            if ( this.modules.hasOwnProperty(prop) ) {
                this.modules[prop]();
            }
        }
    }

}

utils.documentReady(()=>{ new Site(); });
